import Projects from "@/components/site/Projects";

export default function ProjectsPage() {
  return <Projects />;
}
